var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnglish = function SvgEnglish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 3.533C15.767 2.567 13.967 2 12 2v1.533h5.333Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.067h7.2c-.567-.567-1.2-1.1-1.867-1.534H12v1.534Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.6h8.433a11.097 11.097 0 0 0-1.2-1.533H12V6.6Z",
    fill: "#ED4C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.133h9.233c-.233-.533-.5-1.066-.8-1.533H12v1.533Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.667h9.733a11.77 11.77 0 0 0-.5-1.534H12v1.534Z",
    fill: "#ED4C5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.233h9.967c-.034-.533-.134-1.033-.234-1.533H12v1.533Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.967 11.233H12V12H2c0 .267 0 .5.033.767h19.934C22 12.5 22 12.267 22 12s0-.533-.033-.767Z",
    fill: "#ED4C5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.267 14.3h19.466c.134-.5.2-1 .234-1.533H2.033c.034.5.1 1.033.234 1.533Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.767 15.833h18.466c.2-.5.367-1 .5-1.533H2.267c.133.533.3 1.033.5 1.533Z",
    fill: "#ED4C5C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.567 17.367h16.866c.3-.5.567-1 .8-1.534H2.767c.233.534.5 1.034.8 1.534Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.767 18.9h14.466c.434-.467.867-1 1.2-1.533H3.567c.333.566.766 1.066 1.2 1.533Z",
    fill: "#ED4C5C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.633 20.433h10.734c.7-.433 1.3-.966 1.866-1.533H4.767c.566.6 1.2 1.1 1.866 1.533Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c1.967 0 3.8-.567 5.367-1.567H6.633C8.2 21.433 10.033 22 12 22Z",
    fill: "#ED4C5C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 3.533c-.7.434-1.334.967-1.9 1.534-.467.466-.867 1-1.2 1.533-.3.5-.6 1-.8 1.533-.2.5-.367 1-.5 1.534-.134.5-.2 1-.234 1.533C2 11.467 2 11.733 2 12h10V2c-1.967 0-3.767.567-5.333 1.533Z",
    fill: "#428BC1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m9.667 2.333.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM11 4.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM8.333 4.333l.167.5H9l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM9.667 6.333l.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM7 6.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM4.333 6.333l.167.5H5l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM11 8.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM8.333 8.333l.167.5H9l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM5.667 8.333l.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM9.667 10.333l.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM7 10.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM4.333 10.333l.167.5H5l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM5.267 5.667l.4-.3.4.3-.167-.5.4-.334h-.5l-.133-.5-.167.5h-.467l.4.3-.166.534ZM2.6 9.667l.4-.3.4.3-.167-.5.4-.334h-.466L3 8.333l-.167.5H2.5c0 .034-.033.067-.033.1l.266.2-.133.534Z",
    fill: "#fff"
  })));
};
export default SvgEnglish;